<template>
  <div>
    <svg
      width="47"
      height="32"
      viewBox="0 0 47 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5507_22455)">
        <path
          d="M46.5455 29.2983C46.5455 30.818 45.3136 32.0499 43.7941 32.0499H2.75136C1.23182 32.0499 0 30.8178 0 29.2983V2.70153C0 1.18189 1.23182 -0.0499268 2.75136 -0.0499268H43.794C45.3136 -0.0499268 46.5454 1.18198 46.5454 2.70153L46.5455 29.2983Z"
          fill="#34495E"
        />
        <path
          opacity="0.15"
          d="M1.95609 29.2983V2.70153C1.95609 1.18189 3.18809 -0.0499268 4.70764 -0.0499268H2.75127C1.23182 -0.0499268 0 1.18207 0 2.70153V29.2983C0 30.818 1.23182 32.0499 2.75136 32.0499H4.70773C3.18818 32.0499 1.95609 30.8178 1.95609 29.2983Z"
          fill="#202121"
        />
        <path
          d="M28.1258 15.9819C28.1296 15.1059 27.8011 14.2286 27.1401 13.5675C26.4776 12.9051 25.5982 12.5769 24.7204 12.5822C24.7162 12.5822 24.7121 12.5819 24.7077 12.5819C22.8016 12.5819 21.2896 14.0935 21.2896 16.0003C21.2896 17.8882 22.8202 19.4184 24.7077 19.4184C26.6145 19.4184 28.1263 17.9065 28.1263 16.0003C28.1263 15.994 28.1258 15.9881 28.1258 15.9819Z"
          fill="#F26E21"
        />
        <path
          d="M20.6541 17.4463C20.1432 17.9577 19.6717 18.1576 19.1637 18.1684C17.9264 18.1573 17.0167 17.2409 17.0167 15.9345C17.0167 15.2768 17.2657 14.7378 17.6601 14.2774C18.03 13.9262 18.5066 13.6993 19.0546 13.6993C19.6461 13.6993 20.1065 13.8965 20.632 14.4224V12.9105C20.1066 12.6477 19.646 12.5161 19.0546 12.5161C18.2189 12.5758 17.431 12.9135 16.8267 13.4437C16.6525 13.6004 16.4856 13.7734 16.344 13.9714C15.9026 14.5436 15.6357 15.2442 15.6357 16.0005C15.6357 17.9066 17.1482 19.3527 19.0545 19.3527C19.0637 19.3527 19.0729 19.3519 19.0819 19.3518C19.0947 19.352 19.1074 19.3527 19.1201 19.3527C19.6459 19.3527 20.1065 19.2216 20.698 18.9586L20.6541 17.4463C20.6319 17.4685 20.6761 17.4891 20.6541 17.5101V17.4463Z"
          fill="#E7E8E3"
        />
        <path
          d="M32.442 13.4576L30.9533 17.1178L29.244 12.7788H27.8638L30.5589 19.4184H31.2819L34.1087 12.7788H32.7284L32.442 13.4576Z"
          fill="#E7E8E3"
        />
        <path
          d="M34.6348 15.6714V19.2214H38.1848H38.2502V18.1693H37.1328H35.9495V16.9863V16.3948H38.1848V15.2769H35.9495V13.8965H38.2502V12.7788H34.6348V15.6714Z"
          fill="#E7E8E3"
        />
        <path
          d="M4.92108 12.7788H3.08008V19.2214H4.92099C5.9069 19.2214 6.6299 18.9583 7.22153 18.4981C7.94453 17.9064 8.4049 16.9864 8.4049 16.0004C8.40499 14.0935 7.02426 12.7788 4.92108 12.7788ZM6.4329 17.6437C6.03844 17.9723 5.51253 18.1693 4.72362 18.1693H4.32917V13.8964H4.65781C5.44671 13.8964 5.97262 14.0279 6.36717 14.4222C6.82726 14.8164 7.09035 15.4084 7.09035 16.0002C7.15608 16.5918 6.89317 17.2489 6.4329 17.6437Z"
          fill="#E7E8E3"
        />
        <path
          d="M10.2461 12.7782H8.99707V19.2207H10.2461V12.7782Z"
          fill="#E7E8E3"
        />
        <path
          d="M13.4012 15.2768C12.6125 15.0139 12.415 14.8166 12.415 14.488C12.415 14.0936 12.8095 13.7649 13.3354 13.7649C13.7298 13.7649 14.0585 13.8965 14.3872 14.2909L15.0448 13.4364C14.5187 12.976 13.8616 12.7134 13.1384 12.7134C12.0206 12.7134 11.1002 13.5023 11.1002 14.5537C11.1002 15.4743 11.495 15.8687 12.6781 16.3288C13.204 16.5257 13.4013 16.5917 13.533 16.7232C13.7955 16.8545 13.9272 17.1177 13.9272 17.3803C13.9272 17.9063 13.533 18.3008 12.941 18.3008C12.3488 18.3008 11.8234 17.9722 11.5604 17.4462L10.7715 18.2351C11.3634 19.0897 12.0865 19.484 13.0068 19.484C14.3215 19.484 15.2414 18.6295 15.2414 17.3803C15.2416 16.263 14.8475 15.8028 13.4012 15.2768Z"
          fill="#E7E8E3"
        />
        <path
          d="M41.7999 16.5258C42.7857 16.3289 43.3118 15.6713 43.3118 14.6854C43.3118 13.5024 42.457 12.7788 41.011 12.7788H39.1045V19.2214H40.3535V16.6574H40.5509L42.3254 19.2214H43.8376L41.7999 16.5258ZM40.7478 15.7369H40.3536V13.765H40.7478C41.5367 13.765 41.997 14.0935 41.997 14.7514C41.997 15.4084 41.5368 15.7369 40.7478 15.7369Z"
          fill="#E7E8E3"
        />
      </g>
      <defs>
        <clipPath id="clip0_5507_22455">
          <rect
            width="46.5455"
            height="32"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
</template>

<script>
export default {
    name: 'DiscoverIcon',
}
</script>